import React, { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '../../firebaseDDH';
import EnquiriesModal from './EnquiriesModal';
import * as ds from '../../constants/dashboardStyles';

const styles = {
  card: ds.card,
  // No description under this one, so the title carries the spacing itself.
  title: { ...ds.cardTitle, marginBottom: 16 },
  viewButton: {
    width: '100%',
    padding: '10px 12px',
    borderRadius: 8,
    border: '1px solid #ddd',
    background: '#fff',
    color: '#222',
    fontSize: '0.9rem',
    cursor: 'pointer',
  },
};

export default function EnquiriesPanel() {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const q = query(collection(db, 'enquiries'), orderBy('submittedAt', 'desc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setEnquiries(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  return (
    <div style={styles.card}>
      <div style={styles.title}>Contact form messages</div>

      <button type="button" style={styles.viewButton} onClick={() => setModalOpen(true)}>
        {loading ? 'View messages' : `View messages (${enquiries.length})`}
      </button>

      {modalOpen && (
        <EnquiriesModal enquiries={enquiries} loading={loading} onClose={() => setModalOpen(false)} />
      )}
    </div>
  );
}
